import { http } from "../http_service";


/** Report from Employee */
export function reportsEmployees() {
    return http().get(`/reports/employees`);
}